/**
 * TanStack Query hooks for `agency-features`. Thin wrappers over ./api.
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import {
	getAgencyFeatures,
	agencyFeaturesQueryKeys,
	type AgencyFeaturesResponse,
} from "./api";

/**
 * Fetch the plan + feature matrix for the caller. Returns the full shape
 * so the UI can render cross-plan comparison + highlight current plan.
 */
export function useAgencyFeaturesList(): UseQueryResult<
	AgencyFeaturesResponse,
	Error
> {
	return useQuery({
		queryKey: agencyFeaturesQueryKeys.list(),
		queryFn: getAgencyFeatures,
	});
}
